module.exports = __webpack_public_path__ + "media/spinner-wheel-tick.ed534739.mp3";